import React, {useEffect} from 'react';
import {useAppContext, useJobContext, useNotificationContext} from 'contexts';
import {genericMessageHandler} from 'shared/helpers';
import {useGetJobCostQuery} from 'components/customer/Job/store/jobApi';
import {PricingWebhook} from 'shared/components/Header/PricingWebhook';
import {PartialJob} from 'shared/types/PartialJob';
import {LegacyCostBreakdown} from 'shared/components/Header/Cost/LegacyCost';
import {CostBreakdownSimple} from 'shared/components/Header/Cost/CostBreakdownSimple';
import {JOB_STATUS} from 'components/customer/Dashboard/LastJobButton';

const SideBarRightFooter = () => {
    const {job} = useJobContext() as PartialJob;
    const {userProfile} = useAppContext();
    const {notify} = useNotificationContext();
    const {
        data: cost,
        error: errorCost,
        isLoading,
        isFetching,
        isError,
    } = useGetJobCostQuery(
        {jobId: job.id},
        {
            skip: typeof job?.id === 'undefined',
        }
    );

    useEffect(() => {
        if (isError) {
            let errors: string | string[] = 'Error Calculating Job Cost';

            if ('status' in errorCost) {
                if ('data' in errorCost && typeof errorCost.data === 'object') {
                    if ('errors' in errorCost.data) {
                        errors = errorCost.data.errors as string[];
                    } else if ('error' in errorCost.data) {
                        errors = errorCost.data.error as string;
                    }
                } else if ('error' in errorCost) {
                    errors = errorCost.error;
                }
            } else if ('message' in errorCost) {
                errors = errorCost.message;
            }

            if (!Array.isArray(errors)) {
                errors = [errors];
            }

            errors.forEach((error) =>
                genericMessageHandler(notify, {message: error})
            );
        }
    }, [isError, errorCost]);

    if (!userProfile?.show_pricing) {
        if (isError) {
            return null;
        } else {
            return (
                <PricingWebhook
                    messages={cost?.pricingMessages}
                    breakdown={cost?.pricingBreakdown}
                    cost={cost?.totalJobCost}
                />
            );
        }
    }

    return (
        <ul className="totals">
            {userProfile?.jobConfirmationEnabled &&
            job.status == JOB_STATUS.PROCESSING ? (
                <CostBreakdownSimple
                    cost={cost}
                    isLoadingCost={isLoading}
                    isFetchingCost={isFetching}
                />
            ) : (
                <LegacyCostBreakdown
                    cost={cost}
                    isLoadingCost={isLoading}
                    isFetchingCost={isFetching}
                />
            )}

            {job.hasOwnProperty('priceExpireDate') &&
            job.priceExpireDate != null ? (
                <li>
                    Pricing is valid until&nbsp;
                    <strong>{job.priceExpireDate}</strong>
                </li>
            ) : null}
        </ul>
    );
};

export default SideBarRightFooter;
